import { CodeBlock } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const TS_SAMPLE = `import { Chart } from "@aisquare/ui";

export function Dashboard({ spec }) {
  return <Chart spec={spec} height={280} />;
}`;

const PY_SAMPLE = `def fib(n: int) -> int:
    a, b = 0, 1
    for _ in range(n):
        a, b = b, a + b
    return a`;

export function CodeBlockDemo() {
  return (
    <Section
      id="code-block"
      title="CodeBlock"
      description="Syntax-highlighted code with copy. Renderer for the K2 `code` block - props are the streamed `{ language, source }`. Highlighting via react-syntax-highlighter (Prism oneDark), matching <Markdown>."
    >
      <VariantBlock label="With filename + line numbers">
        <div className="w-full max-w-xl">
          <CodeBlock language="tsx" filename="Dashboard.tsx" source={TS_SAMPLE} showLineNumbers />
        </div>
      </VariantBlock>

      <VariantBlock label="Language label only">
        <div className="w-full max-w-xl">
          <CodeBlock language="python" source={PY_SAMPLE} />
        </div>
      </VariantBlock>

      <VariantBlock label="States">
        <div className="w-full max-w-xl space-y-4">
          <CodeBlock language="ts" source="" />
          <CodeBlock language="ts" source="loading..." loading />
          <CodeBlock language="ts" source="x" error />
        </div>
      </VariantBlock>
    </Section>
  );
}
